import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import {
  addAccountActivationAction,
  changePasswordActiveAccount,
  forgetResetPasswordAction,
  getChangePasswordAction,
  getCustomerLoginResponse,
  getForgetPasswordAction,
  getUserAction,
  getUserProfile,
  resentLinkCustomerPortalAction,
  sendOtpAction,
  setAccountActivationAction,
  setAccountActivationMessage,
  setChangePasswordAction,
  setChangePasswordActiveAccountResponse,
  setCustomerLinkErrorResponse,
  setCustomerLoginResponse,
  setCustomerTokenInValidAction,
  setFileUploadModulePermissionAction,
  setForgetPasswordAction,
  setForgetResetPasswordAction,
  setInvoiceModulePermissionAction,
  setLeadArchieveModulePermissionAction,
  setLeadCompletionModulePermissionAction,
  setLeadConfirmationModulePermissionAction,
  setLeadEstimateModulePermissionAction,
  setLeadJobModulePermissionAction,
  setLeadLogModulePermissionAction,
  setLeadModulePermissionAction,
  setLeadProvisionalModulePermissionAction,
  setLeadQuotationModulePermissionAction,
  setLeadSurveyModulePermissionAction,
  setLoginFailedResponse,
  setLogoutAction,
  setLogoutResponseAction,
  setNotificationModulePermissionAction,
  setPaymentModulePermissionAction,
  setPermissionsAction,
  setResentLinkCustomerPortalAction,
  setSelectedForgetEmailAction,
  setSendOtpAction,
  setSettingCompanyModulePermissionAction,
  setSettingDocumentModulePermissionAction,
  setSettingFeedbackModulePermissionAction,
  setSettingOwnerModulePermissionAction,
  setSettingRoleModulePermissionAction,
  setSettingStaffModulePermissionAction,
  setSettingWorkerModulePermissionAction,
  setSurveyTaskModulePermissionAction,
  setUpdateProfileError,
  setUpdateProfileSuccess,
  setUserAction,
  setUserProfile,
  setVerifyOtpAction,
  setWorkDiaryModulePermissionAction,
  updateUserProfileAction,
  verifyOtpAction,
} from "../reducers/userSlice";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import store, { persistor } from "../store";
import { convertPermissions, getModulePermissionFlags } from "../../hooks/helper";
import { setSingleLeadAction } from "../reducers/leadSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */
function* getUserSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  
  try {
    const users = yield call<any>(
      callAPI,
      payload,
      "post",
      "auth/client-signin"
    );
   
    if (users?.data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + users?.data?.accessToken;
      yield put(setUserAction(users?.data));
      yield put(setAccountActivationMessage(null));
      localStorage.setItem("userName",JSON.stringify(payload?.payload?.usernameOrEmail));
      localStorage.setItem("password",JSON.stringify(payload?.payload?.password));
      localStorage.setItem("user", JSON.stringify(users?.data));
      localStorage.setItem("nextAction",JSON.stringify(users?.data?.nextAction));
      localStorage.setItem("isSeenNotification", "false");
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    const responseData = error?.response?.data;
    const isActiveSessionError =
      responseData?.details?.isActiveSession === true;

    if (error?.response && !isActiveSessionError) {
      handleError(error?.response);
    }
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setLoginFailedResponse(error?.response?.data));
  }
  yield put(setLoaderAction(false));
}

function* getUserProfileSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("plans-try");
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const userProfile = JSON.parse(storedUser);
      const userRole = userProfile?.user?.roles;

      let endpoint = "client/me";
      if (userRole.includes("CUSTOMER") || userRole.includes("Customer")) {
        endpoint = "customers/me";
      }

      const profile = yield call<any>(callAPI, {}, "get", endpoint);
      console.log("profile-", profile);
      if (profile?.data) {
        yield put(setUserProfile(profile?.data));
        if (profile?.data?.modulePermission?.length > 0) {

          const permissions = convertPermissions(
            profile.data.modulePermission
          );

          yield put(setPermissionsAction(permissions));

        }
        if(profile?.data?.modulePermission && profile?.data?.modulePermission?.length > 0){

          // client permission
          const invoiceModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Invoice");
          const leadModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead");   
          const leadArchieveModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Archive"); 
          const leadCompletionModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Completion");
          const leadCofirmationModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Confirmation");
          const leadEstimateModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Estimate");
          const leadJobModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Job");
          const leadLogModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Log");
          const leadProvisionalModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Provisional");
          const leadQuotationModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Quotation");
          const leadSurveyModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Lead:Survey");
          const notificationModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Notification");
          const paymentModulePermission =getModulePermissionFlags(profile.data.modulePermission, "Payment")
          const companyModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Setting:Company");  
          const settingDocumentModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Setting:Document");
          const settingFeedbackModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Setting:Feedback");
          const settingOwnerModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Setting:Owner");
          const settingRoleModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Setting:Role");  
          const settingStaffModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Setting:Staff");   
          const surveyTaskModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Survey Tasks");
          const workDiaryModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Work Diary");
          const fileUploadModulePermission = getModulePermissionFlags(profile.data.modulePermission, "File Upload");
          const settingWorkerModulePermission = getModulePermissionFlags(profile.data.modulePermission, "Setting:Worker And Vehicle");
          yield put(setInvoiceModulePermissionAction(invoiceModulePermission));
          yield put(setLeadModulePermissionAction(leadModulePermission));
          yield put(setLeadArchieveModulePermissionAction(leadArchieveModulePermission));
          yield put(setLeadCompletionModulePermissionAction(leadCompletionModulePermission));
          yield put(setLeadConfirmationModulePermissionAction(leadCofirmationModulePermission));
          yield put(setLeadEstimateModulePermissionAction(leadEstimateModulePermission));
          yield put(setLeadJobModulePermissionAction(leadJobModulePermission));
          yield put(setLeadLogModulePermissionAction(leadLogModulePermission));
          yield put(setLeadProvisionalModulePermissionAction(leadProvisionalModulePermission));
          yield put(setLeadQuotationModulePermissionAction(leadQuotationModulePermission));
          yield put(setLeadSurveyModulePermissionAction(leadSurveyModulePermission));
          yield put(setSettingCompanyModulePermissionAction(companyModulePermission));
          yield put(setSettingRoleModulePermissionAction(settingRoleModulePermission));
          yield put(setSettingStaffModulePermissionAction(settingStaffModulePermission));
          yield put(setSettingDocumentModulePermissionAction(settingDocumentModulePermission));
          yield put(setSettingFeedbackModulePermissionAction(settingFeedbackModulePermission));
          yield put(setSettingOwnerModulePermissionAction(settingOwnerModulePermission));
          yield put(setSurveyTaskModulePermissionAction(surveyTaskModulePermission));
          yield put(setWorkDiaryModulePermissionAction(workDiaryModulePermission));
          yield put(setNotificationModulePermissionAction(notificationModulePermission));
          yield put(setPaymentModulePermissionAction(paymentModulePermission));
          yield put(setFileUploadModulePermissionAction(fileUploadModulePermission));
          yield put(setSettingWorkerModulePermissionAction(settingWorkerModulePermission));
        }
      }
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getChangePasswordSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/me/change-password"
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setChangePasswordAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setChangePasswordAction(false));
  }
  yield put(setLoaderAction(false));
}

function* addAccountActivationSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/me/activate"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAccountActivationAction(true));
      if(apiResponse?.data?.message === "Your account has been activated successfully but you do not have an active subscription plan. Please contact Manage My Moves Admin"){
        yield put(setAccountActivationMessage(apiResponse?.data?.message || null));
      }else {
        yield call(getUserProfileSaga);
        yield put(setAccountActivationMessage(null));
      }
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAccountActivationAction(false));
    if(error?.response?.data?.message === "Your account has been activated successfully but you do not have an active subscription plan. Please contact Manage My Moves Admin"){
      const userDetail: any = localStorage.getItem('user');
          if(userDetail){
            setTimeout(() => {
              localStorage.removeItem('user');
              localStorage.removeItem('persist:root');
              store.dispatch(setUserAction([]))
              store.dispatch(setUserProfile([]))
              window.location.href = '/'
              return false;
            }, 5000);
          }
    }
  }
  yield put(setLoaderAction(false));
}

function* changePasswordActiveAccountSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/me/change-password"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setChangePasswordActiveAccountResponse(true));
      
        yield call(getUserProfileSaga);
        yield put(setAccountActivationMessage(null));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setChangePasswordActiveAccountResponse(false));
    if(error?.response?.data?.message === "Your account has been activated successfully but you do not have an active subscription plan. Please contact Manage My Moves Admin"){
      const userDetail: any = localStorage.getItem('user');
          if(userDetail){
            setTimeout(() => {
              localStorage.removeItem('user');
              localStorage.removeItem('persist:root');
              store.dispatch(setUserAction([]))
              store.dispatch(setUserProfile([]))
              window.location.href = '/'
              return false;
            }, 5000);
          }
    }
  }
  yield put(setLoaderAction(false));
}

function* updateUserProfileSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(callAPI, payload, "put", `client/me`);
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateProfileSuccess(true));
      yield put(setUpdateProfileError(false));
      yield put(getUserProfile());
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateProfileSuccess(false));
    yield put(setUpdateProfileError(true));
  }
  yield put(setLoaderAction(false));
}

function* getForgetPasswordSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload",payload);
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `auth/forgot-password`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setForgetPasswordAction(true));
      yield put(setSelectedForgetEmailAction(payload));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setForgetPasswordAction(false));
  }
  yield put(setLoaderAction(false));
}

function* forgetResetPasswordSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload",payload);
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `auth/reset-password`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setForgetResetPasswordAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error?.response);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setForgetResetPasswordAction(false));
  }
  yield put(setLoaderAction(false));
}

function* logoutSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "auth/signout"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success) {
      localStorage.removeItem("user");
      localStorage.removeItem("nextAction");
      localStorage.removeItem("isSeenNotification");
      localStorage.removeItem("userName");
      localStorage.removeItem("password");
      localStorage.clear();
    sessionStorage.clear();
      store.dispatch(setUserAction([]));
      store.dispatch(setUserProfile([]));
      persistor.purge(); // Clears persisted Redux state
      apiResponse && handleSuccess(apiResponse);
      yield put(setLogoutResponseAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response);
    yield put(setLogoutResponseAction(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getCustomerLoginResponseSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload-427",payload); 
  const { token,tenantId,customerId } = payload.payload?.payload;
  try {
    const response = yield call<any>(
      callAPI,
      {},
      "get",
      `public/customer/verify-token?token=${token}&tenant_id=${tenantId}&customer_id=${customerId}`
    );
    console.log("response-", response);
    if (response?.data) {
      yield put(setCustomerLoginResponse(response));
      yield put(setCustomerTokenInValidAction(false));
      yield put(setCustomerLinkErrorResponse(null));
      yield put(setVerifyOtpAction(false));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setCustomerLoginResponse(null));
    yield put(setCustomerLinkErrorResponse(error?.response?.data || "Too many access attempts. Please contact your removal company."));
    yield put(setCustomerTokenInValidAction(true));
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
} 

function* resentLinkCustomerPortalSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload-456",payload);
  try {
    const response = yield call<any>(
      callAPI,
      payload,
      "post",
      `public/customer/resend-link`
    );
    console.log("response-", response);
    if (response?.success === true) {
      response && handleSuccess(response);
      yield put(setResentLinkCustomerPortalAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setResentLinkCustomerPortalAction(false));
  }
  yield put(setLoaderAction(false));
}

function* sendOtpSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload-486",payload);
  try {
    const response = yield call<any>(
      callAPI,
      payload,
      "post",
      `public/customer/send-otp`
    );
    console.log("response-", response);
    if (response?.success === true) {
      response && handleSuccess(response);
      yield put(setSendOtpAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSendOtpAction(false));
  }
  yield put(setLoaderAction(false));
}

function* verifyOtpSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload-516",payload);
  try {
    const response = yield call<any>(
      callAPI,
      payload,
      "post",
      `public/customer/verify-otp`
    );
    console.log("response-", response);
    if (response?.success === true) {
      response && handleSuccess(response);
      yield put(setVerifyOtpAction(true));
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + response?.data?.accessToken;
      yield put(setUserAction(response?.data));
      yield put(setAccountActivationMessage(null));
      localStorage.setItem("user", JSON.stringify(response?.data));
      localStorage.setItem("nextAction",JSON.stringify(response?.data?.nextAction));
      localStorage.setItem("isSeenNotification", "false");
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setVerifyOtpAction(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchUser() {
  yield takeLatest<any>(getUserAction, getUserSaga);
  yield takeLatest<any>(getUserProfile, getUserProfileSaga);
  yield takeLatest<any>(getChangePasswordAction, getChangePasswordSaga);
  yield takeLatest<any>(addAccountActivationAction, addAccountActivationSaga);
  yield takeLatest<any>(changePasswordActiveAccount, changePasswordActiveAccountSaga);
  yield takeLatest<any>(updateUserProfileAction, updateUserProfileSaga);
  yield takeLatest<any>(getForgetPasswordAction, getForgetPasswordSaga);
  yield takeLatest<any>(forgetResetPasswordAction,forgetResetPasswordSaga);
  yield takeLatest<any>(setLogoutAction, logoutSaga);
  yield takeLatest<any>(getCustomerLoginResponse, getCustomerLoginResponseSaga);
  yield takeLatest<any>(resentLinkCustomerPortalAction, resentLinkCustomerPortalSaga);
  yield takeLatest<any>(sendOtpAction,sendOtpSaga);
  yield takeLatest<any>(verifyOtpAction,verifyOtpSaga);
}
